import { MediumProduct, OrderSearchModel } from '@/types/index'

type InstantSearchTitle = { type: InstantSearchType; text: string }

enum InstantSearchType {
  PRODUCT = 'PRODUCT',
  ORDER = 'ORDER'
}

type InstantSearchItem = MediumProduct | OrderSearchModel | InstantSearchTitle

export { InstantSearchItem, InstantSearchTitle, InstantSearchType }
